import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { WasteTagFilterMode } from "generated-graphql/graphql";

interface WasteTagModeToggleProps {
  value: WasteTagFilterMode;
  onChange: (mode: WasteTagFilterMode) => void;
  ariaLabel: string;
}

export function WasteTagModeToggle({ value, onChange, ariaLabel }: WasteTagModeToggleProps) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_e, newMode: WasteTagFilterMode | null) => {
        if (!newMode) return;
        onChange(newMode);
      }}
      aria-label={ariaLabel}
    >
      <Tooltip title="Show rows that have at least one of the selected tags">
        <ToggleButton
          value={WasteTagFilterMode.Any}
          sx={{ py: 0.25, px: 1, textTransform: "none" }}
        >
          Any
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Show rows that have every selected tag (and may have additional tags)">
        <ToggleButton
          value={WasteTagFilterMode.All}
          sx={{ py: 0.25, px: 1, textTransform: "none" }}
        >
          All
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Show rows whose tags exactly match the selected set">
        <ToggleButton
          value={WasteTagFilterMode.Only}
          sx={{ py: 0.25, px: 1, textTransform: "none" }}
        >
          Only
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
